import { toast, ToastPosition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const handleSuccess = (info, type) => {
  toast.success(info, {
    position: "top-right", // or use ToastPosition.TOP_RIGHT
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

const handleError = (info) => {
  toast.error(info, {
    position: "top-right",
  });
};

export { handleError, handleSuccess };
